import { render, staticRenderFns } from "./RegionKey.vue?vue&type=template&id=6ec4cd9c&"
import script from "./RegionKey.vue?vue&type=script&lang=js&"
export * from "./RegionKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ec4cd9c')) {
      api.createRecord('6ec4cd9c', component.options)
    } else {
      api.reload('6ec4cd9c', component.options)
    }
    module.hot.accept("./RegionKey.vue?vue&type=template&id=6ec4cd9c&", function () {
      api.rerender('6ec4cd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/RegionKey.vue"
export default component.exports